interface AuthStore {
  token?: string;
  role?: string;
  selectedCompanyId?: string;
  isOnFrontoffice?: boolean;
}

export abstract class AuthStorage {
  private static store: AuthStore = {};

  public static getItem<Key extends keyof AuthStore>(key: Key): AuthStore[Key] {
    return this.store[key];
  }

  public static setItem<Key extends keyof AuthStore>(
    key: Key,
    value: AuthStore[Key]
  ) {
    this.store[key] = value;
  }

  public static removeItem(key: keyof AuthStore) {
    this.store[key] = undefined;
  }

  public static clear() {
    this.store = {};
  }
}
